
import {throwError as observableThrowError,  Observable } from 'rxjs';
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpEvent,
  HttpErrorResponse
} from "@angular/common/http";
import { LocalStorageService } from "ngx-webstorage";
import { Injector, Injectable } from "@angular/core";
import { secret } from "app/app.env";
import { catchError, map } from "rxjs/operators";
import { environment } from "environments/environment";
import { Router } from "@angular/router";
import * as CryptoJS from 'crypto-js';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private injector: Injector,
    private localSt: LocalStorageService,
    private router: Router
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const localSt = this.injector
      .get(LocalStorageService)
      .retrieve(secret.userData);
    if (localSt !== null) {
      const tsToken = localSt.token;
      const codeCobra = localSt.codeCobra;
      const authReq = req.clone({
        setHeaders: { "tsx-access-token": tsToken, "ts-access-token": tsToken, codeCobra: codeCobra }
      });
      return next.handle(authReq).pipe(
        map((res: any) => {
          if (
            typeof res.body != 'undefined' &&
            typeof res.body.result != 'undefined' &&
            typeof res.body.data == "string" &&
            res.body.result.iv
          ) {
            const key = CryptoJS.enc.Utf8.parse(environment.cryptoKey);
            const iv  = CryptoJS.enc.Utf8.parse(res.body.result.iv);

            const plaintextArray = CryptoJS.AES.decrypt({
              ciphertext: CryptoJS.enc.Base64.parse(res.body.data),
              salt: ''
            }, key, {
              iv: iv, mode: CryptoJS.mode.CBC
            });

            const decrypted_data = CryptoJS.enc.Utf8.stringify(plaintextArray)

            res.body.data = JSON.parse(decrypted_data)
          }

          return res;
        }),
        catchError(error => {
          if (error instanceof HttpErrorResponse) {
            if (error.error.result.code == 9) {
              this.clearLocalStorage();
            }
          }
          return observableThrowError(error);
        })
      );
    } else {
      return next.handle(req);
    }
  }

  clearLocalStorage() {
    const userData = this.localSt.retrieve(secret.userData);
    const tsDebtor = this.localSt.retrieve(secret.tsDebtor);
    const contracts = this.localSt.retrieve(secret.contracts);
    const chat = this.localSt.retrieve(secret.chat);

    if (
      userData != null ||
      chat != null ||
      contracts != null ||
      tsDebtor != null
    ) {
      this.localSt.clear();
      this.router.navigate(["/"]);
    }
  }
}
